/**
 * Archimago. "Tap → Play or draw a site.
 *
 *               Banish three magic spells in your cemetery → Cast a
 *               copy of one of them."
 *
 * The Tap line is the standard avatar builtin (handled by GameBoard's
 * `_builtin: 'avatar_site'`). The second clause is an activated
 * ability with a banish-three-magics cost. No tap, no mana. Players
 * may fire it any number of times per turn as long as the cemetery
 * still holds three Magic spells.
 *
 * Registered here as an `extraActivatedAbilities` entry with the
 * `_builtin: 'archimago_cast_copy'` discriminator. GameBoard's
 * `_activateAbility` dispatches to the cemetery-picker flow; pick three
 * Magic spells, then pick one of those three to cast a copy of. The
 * three picks become Banished; the chosen copy resolves via the
 * standard standalone-spell pipeline and is then banished as well.
 *
 * Pure helpers (cemetery query / Magic-type predicate) live at
 * `engine/automation/ops/archimago.js` so GameBoard's gate logic and
 * the resolve handler share one source of truth.
 */
export const ARCHIMAGO_RULES = {
  extraActivatedAbilities: [
    {
      id: '__builtin_archimago_cast_copy',
      trigger: 'activated',
      cost: [],
      description: 'Banish 3 magic spells: cast a copy',
      _builtin: 'archimago_cast_copy',
    },
  ],
};
